// extracted by mini-css-extract-plugin
export var icon = "_b4-3";
export var subtitle = "_b4-2";
export var title = "_b4-1";
export var value = "_b4-0";